export default class SelectDataBinding {
  constructor(label, propertyName, options) {
    this.label = label;
    this.propertyName = propertyName;
    this.options = options;
  }
}
